import React from 'react'
import { inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import classnames from 'classnames'

import CopyGeometryButton from 'components/common/tooltips/CopyGeometryButton'
import MoveGeometryButton from 'components/common/tooltips/MoveGeometryButton'
import DeleteItemPrompt from 'components/tools/item/DeleteItemPrompt'
import Icon from 'components/common/Icon'

const MultiItemPane = ({ uiStore, selectionStore, t, geopolygon, group }) => {
  return (
    <div className='multi-pane'>
      <div className={classnames({ 'multi-pane__disabled': selectionStore.selectedItemsHasGroup })}>
        <CopyGeometryButton
          lgIcon
          group={group}
          onSubmit={() => uiStore.copyGeopolygonBulk()}
        />
      </div>
      <div className={classnames({ 'multi-pane__disabled': selectionStore.selectedItemsHasGroup })}>
        <MoveGeometryButton
          lgIcon
          group={group}
          onSubmit={() => uiStore.moveGeoBulk(group)}
        />
      </div>
      <button
        className='delete'
        onClick={(e) => {
          e.stopPropagation()
          uiStore.openDeletePrompt({
            style: {
              width: 300
            },
            selector: '.multi-pane__delete',
            text: (<DeleteItemPrompt item={group} itemName={`items: ${selectionStore.selectedMenuItemNames.join(', ')}`} onSubmit={() => { uiStore.deleteGeoBulk() }} />)
          })
        }}
      >
        <Icon id='fa-trash-o' extraClasses={['icon-lg']} />
        <span className='multi-pane__delete'>{t('GLOBAL.DELETE')}</span>
      </button>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'selectionStore')(MultiItemPane))
